import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { categoryMap } from "@/mocks/categories";

export function formatHeat(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export default function ArticleCard({ article }: { article: Article }) {
  const cat = categoryMap[article.category];
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={article.cover}
          alt={`${article.title}漫画封面`}
          title={`${article.title} 高分漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
          {article.rating.toFixed(1)} 分
        </span>
        <span className="absolute bottom-2 right-2 rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {cat?.name ?? "漫画"} · {article.status}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 md:text-base">
          {article.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {article.summary}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-1.5">
          {article.tags.slice(0, 3).map((t) => (
            <span
              key={t}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {t}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-fill text-primary-500"></i>
            {formatHeat(article.heat)} 热度
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.chapters}话
          </span>
        </div>
      </div>
    </Link>
  );
}